export default __webpack_public_path__ + "static/media/mostro_design_rights.d2991908.png";